<!-- crud asignar url de la api URL="url de la api" titulo="un titulo para la pestaña de la pagina" [dato]="variable que contiene el formulario]-->
<app-formulario #ctrl URL="venta" titulo="Devolución" [dato]="dato"></app-formulario>

<!-- Menu principal "-->
<app-sistema-menu></app-sistema-menu>

<form name="form" novalidate [formGroup]="dato" (ngSubmit)="enviar();">
    <div class="contenedor columns " style=" overflow-y:auto; overflow-x: hidden; height:94vh;">

        <!-- apartado de movimientos_articulos -->
        <div class="column" style="padding:0em;">
            <div style="background: #FFF; border-radius: 0em; ">
                <section class="hero is-primary">
                    <div class="hero-body">
                        <div class="container is-fluid">
                            <h1 class="title">
                                <span *ngIf="!ctrl.cargando || !cargando" class="icon is-medium"><i class="fa fa-edit"></i></span>
                                <span *ngIf="ctrl.cargando || cargando" class="icon is-medium"><i class="fa fa-refresh fa-spin"></i></span>                                Artículos
                            </h1>

                        </div>
                    </div>
                </section>
                <div class="is-fullwidth has-text-centered" *ngIf="!ctrl.datosCargados">
                    <br>
                    <span class="tag is-primary is-large "><span class="icon"><i class="fa fa-refresh fa-spin"></i></span> &nbsp;<span>Cargando...</span></span>
                </div>
                <section >
                    <div class="notification is-warning" *ngIf="!caja_abierta && ctrl.configuracion.sucursal.notificar_caja_cerrada">
                        ¡No se ha detectado ninguna caja abierta! <strong>Puede realizar la devolución</strong>, Pero se recomienda
                        que se habra la caja <a class="button is-small" routerLink="../../../caja/nuevo">Abrir una caja</a>
                    </div>
                    <div class="notification is-danger" *ngIf="error_venta">
                        ¡No se completo la devolución! <strong>Intente de nuevo</strong>, Si no contacte con soporte
                    </div>
                    <div class="notification is-success" *ngIf="venta_ok">
                        Devolución realizada con exito <strong>Puede seguir</strong>
                    </div>

                    <div formArrayName="movimientos_articulos" style="overflow:auto; display:block" [style.height.px]="tamano-225">
                        <div class="box" *ngFor="let val of ctrl.dato.controls.movimientos_articulos.controls;  let i = index;" [ngStyle]="{'background': i%2 == 0 ? 'rgba(230, 230, 232, 0.44)' : 'rgba(237, 242, 243, 0.44)'}">
                            <article class="media" [formGroupName]="i">
                                <div class="media-content">
                                    <div class="content">

                                        <div class="columns">
                                            <div class="column is-4">
                                                <strong>NOMBRE: </strong> {{val.get("articulos").value.nombre}}
                                            </div>

                                            <div class="column is-2">
                                                <label class="label">Precio</label>
                                                 {{(val.get("precio_unitario").value) | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                            </div>

                                            <div class="column is-1">
                                                <label class="label">Cantidad</label>
                                                <strong class="tag is-info is-medium">{{val.get("cantidad").value}}</strong>
                                            </div>

                                            <div class="column is-2">
                                                <label class="label">A devolver</label>
                                                <strong class="tag is-medium">{{val.get("cantidad_devolucion").value}}</strong>
                                            </div>

                                            <div class="column is-3">
                                                <label class="label">Importe</label>

                                                <span class="tag is-medium">{{(val.get("cantidad").value * val.get("precio_unitario").value) | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}</span>
                                                <span class="tag is-success is-medium">{{(val.get("cantidad").value - val.get("cantidad_devolucion").value ) * (val.get("precio_unitario").value) | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}</span>

                                            </div>
                                        </div>
                                        <div *ngIf="ctrl.configuracion.sucursal.control_lote == 1">
                                            <button (click)="seleccionar_stock(val.get('articulos').value.stocks, i); ctrl.abrirModal('abrirstock');" class="button is-fullwidth is-info"
                                                type="button" *ngIf="val.get('cantidad_restante').value > 0">Seleccionar lote</button>

                                            <table class="table">
                                                <thead>
                                                    <tr>
                                                        <th>Lote</th>
                                                        <th>Caducidad</th>
                                                        <th>Existencia</th>
                                                        <th>Cantidad</th>
                                                        <th>Cantidad a devolver</th>
                                                    </tr>
                                                </thead>
                                                <tbody formArrayName="stocks">
                                                    <tr *ngFor="let stck of val.controls.stocks.controls; let x = index;" [formGroupName]="x">
                                                        <td>{{stck.value.lote}}</td>
                                                        <td>{{stck.value.fecha_caducidad}}</td>
                                                        <td>{{stck.value.existencia}}</td>
                                                        <td><strong class="tag is-link is-medium">{{stck.get("cantidad").value}}</strong></td>
                                                        <td>
                                                            <p class="control is-expanded  has-icon has-icon-right">
                                                                <input class="input has-text-centered" id="cantidad{{i}}{{x}}" formControlName="cantidad_devolucion" type="number" placeholder="Cantidad"
                                                                    step="1" min="1" [max]="stck.get('cantidad').value"
                                                                    (change)="cambio_cantidad_stock(ctrl.dato.controls.movimientos_articulos.controls[i].controls, ctrl.dato.controls.movimientos_articulos.controls[i].controls.stocks.controls, x)"
                                                                    (keyup)="cambio_cantidad_stock_key($event, ctrl.dato.controls.movimientos_articulos.controls[i].controls, ctrl.dato.controls.movimientos_articulos.controls[i].controls.stocks.controls, x)">

                                                            </p>
                                                        </td>

                                                    </tr>
                                                </tbody>
                                            </table>
                                        </div>
                                    </div>
                                </div>
                            </article>
                        </div>
                    </div>
                </section>
            </div>
        </div>

        <!-- datos del cliente y los importes -->
        <div class="column is-one-third" style="padding:0em;">

            <div style="background: #FFF; border-radius: 0em; ">
                <section class="hero is-primary">
                    <div class="hero-head">
                        <nav class="level">
                            <!-- Left side -->
                            <div class="level-left">
                                <div class="level-item">
                                    <p class="title is-4" style=" padding-left: 10px; ">
                                        <span class="icon is-medium">
                                            <i class="fa fa-file-text"></i>
                                        </span> Devolución
                                    </p>
                                </div>


                            </div>

                            <!-- Right side -->
                            <div class="level-right">

                                <a class="navbar-item is-primary tooltip" (click)="ctrl.regresar()">
                                    <span class="icon fa-2x">
                                        <i class="fa fa-arrow-left"> </i>
                                    </span>
                                    <span class="tooltiptext">Regresar</span>
                                </a>

                                <a class="navbar-item is-primary tooltip" (click)="ctrl.cargarDatos()" id='cargar_datos_actualizar' *ngIf="ctrl.id">
                                    <span class="icon fa-2x">
                                        <i class="fa fa-refresh"></i>
                                    </span>
                                    <span class="tooltiptext">Actualizar</span>
                                </a>

                                <a class="navbar-item is-primary tooltip" routerLink="{{url_nuevo}}" *ngIf="ctrl.id">
                                    <span class="icon fa-2x">
                                        <i class="fa fa-file"></i>
                                    </span>
                                    <span class="tooltiptext">Nuevo</span>
                                </a>

                                <button class="navbar-item  tooltip" type="button" (click)="imprimir()" *ngIf="reimprimir">
                                    <span class="icon fa-2x has-text-info">
                                        <i class="fa fa-print"> </i>
                                    </span>
                                    <span class="tooltiptext">Reimprimir el ticket</span>
                                </button>

                                <button class="navbar-item  tooltip" type="submit" [ngClass]="{'is-loading': cargando}" [disabled]="ctrl.dato.invalid || cargando" *ngIf="!tieneid">
                                    <span class="icon fa-2x has-text-success">
                                        <i class="fa fa-save"> </i>
                                    </span>
                                    <span class="tooltiptext">Guardar</span>
                                </button>

                            </div>
                        </nav>
                    </div>
                </section>
                <div style="padding: 1em;">

                    <!-- cargar los catalogos que se requieran parametro 1 modelo donde se guarda el catalogo, parametro 2 ruta de la api -->
                    <a id="catalogos" (click)="ctrl.cargarCatalogo('clientes', 'cliente?id=2'); ctrl.cargarCatalogo('metodos_pagos', 'tipo-metodo-pago'); ctrl.cargarCatalogo('formas_pagos', 'tipo-forma-pago');"></a>
                    <h3 class="title">
                        <i class="fa fa-file"></i> Datos de la venta
                    </h3>
                    <div class="field">
                        <label class="label">Cliente (opcional):</label>
                        <ng-select2 name="personas_id" [options]="ctrl.optionSelect" [value]="startValue" (valueChanged)="ctrl.seleccionarValorSelect2($event, ctrl.dato.controls.personas_id); "
                            [data]="ctrl.clientes"></ng-select2>
                    </div>
                    <div class="field">
                        <label class="label">Comentarios:</label>
                        <p class="control is-expanded  has-icon has-icon-right">
                            <textarea class="textarea" type="text" rows="2" placeholder="Comentarios" formControlName="comentarios"></textarea>
                        </p>
                    </div>

                    <hr>

                    <div class="card">
                        <header class="card-header">
                            <p class="card-header-title">
                                Formas de pago
                            </p>
                            <a class="card-header-icon">
                            <span class="icon fa-2x">
                                <i class="fa fa-money"></i>
                            </span>
                            </a>
                        </header>
                        <div class="card-content">

                            <div formArrayName="pagos">
                                <div class="content" *ngFor="let item of ctrl.dato.controls.pagos.controls; let i=index">
                                    <div class="box" [formGroupName]="i">
                                        <article class="media" *ngIf="item.value.id > 0">

                                            <div class="media-content">
                                                <label>Pago: </label>
                                                {{item.value.paga_con | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}

                                                {{item.value.tipos_formas_pagos.nombre}}

                                                {{item.value.tipos_metodos_pagos.nombre}}
                                            </div>
                                        </article>
                                        <article class="media" *ngIf="!item.value.id">

                                            <div class="media-content">
                                                <div style="display:flow-root">
                                                    <strong *ngIf="item.value.es_abono" style="float:left">
                                                        Devolución
                                                    </strong>
                                                    <a style="float:right" *ngIf="!tieneid && !item.value.es_abono" class="button is-danger is-small" (click)="ctrl.quitar_form_array(ctrl.dato.controls.pagos, i); calcular_importe_articulo();">
                                                        <span class="icon">
                                                            <i class="fa fa-minus"></i>
                                                        </span>
                                                    </a>
                                                </div>
                                                <div class="columns">
                                                    <div class="column is-6">
                                                        <label>Forma de pago: </label>
                                                        <div class="select">
                                                            <select class="select" name="tipos_formas_pagos_id" formControlName="tipos_formas_pagos_id">
                                                                <option *ngFor="let val of ctrl.formas_pagos" value="{{val.id}}">{{ val.nombre }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                    <div class="column is-6">

                                                        <label>Pago: </label>
                                                        <p class="control is-expanded  has-icon has-icon-right">
                                                            <input class="input has-text-centered is-success" type="number" step="0.1" min="0" placeholder="Pago" formControlName="importe"
                                                                [ngClass]="{'is-danger': !item.controls.importe.valid}">

                                                            <span class="icon is-small" *ngIf="!item.controls.importe.valid">
                                                                <i class="fa fa-warning"></i>
                                                            </span>
                                                            <span class="help is-danger" *ngIf="!item.controls.importe.valid">Este campo es requerido.</span>
                                                        </p>
                                                    </div>

                                                </div>
                                                <div class="columns">
                                                    <div class="column is-6">
                                                        <label>Paga con: </label>
                                                        <p class="control is-expanded  has-icon has-icon-right" *ngIf="!item.value.es_abono">
                                                            <input class="input has-text-centered is-warning" (keyup)="validar_cantidad_pago($event, ctrl.dato.controls.pagos.controls[i].controls.paga_con, ctrl.dato.get('pagos').value[i].importe, 'min', i); "
                                                                type="number" step="0.1" min="{{ctrl.dato.get('pagos').value[i].importe}}" placeholder="Paga con" formControlName="paga_con">
                                                        </p>
                                                        <p class="control is-expanded  has-icon has-icon-right" *ngIf="item.value.es_abono">
                                                            <input class="input has-text-centered is-warning" type="text" placeholder="Paga con" formControlName="paga_con" readonly>
                                                        </p>
                                                    </div>
                                                    <div class="column is-6">
                                                        <label>Cambio: </label>
                                                        <p class="control is-expanded  has-icon has-icon-right">
                                                            <input class="input has-text-centered is-dark" readonly placeholder="Cambio" formControlName="cambio">
                                                        </p>
                                                    </div>
                                                </div>
                                                <div class="columns">
                                                    <div class="column is-12">
                                                        <label>Metodo de pago: </label>
                                                        <div class="select">
                                                            <select class="select" name="tipos_metodos_pagos_id" formControlName="tipos_metodos_pagos_id">
                                                                <option *ngFor="let val of ctrl.metodos_pagos" value="{{val.id}}">{{ val.nombre }}</option>
                                                            </select>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </article>
                                    </div>
                                </div>
                                <footer class="card-footer" *ngIf="agregar_pago">
                                    <a class="card-footer-item" (click)="agregar_forma_pago(ctrl.dato.controls.pagos, form_pagos); calcular_importe_articulo();">
                                        <span class="icon fa-2x has-text-success">
                                            <i class="fa fa-plus"></i>
                                        </span>
                                        &nbsp;Agregar otro</a>
                                </footer>
                            </div>
                        </div>

                    </div>

                    <nav class="panel" style="font-size:1.5em">
                        <p class="panel-heading">
                            Cobro: {{ctrl.dato.get('temp_total').value | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                        </p>

                        <a class="panel-block is-active">
                            <span class="panel-icon">
                            <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Subtotal:
                                </div>
                                <div class="column is-6">
                                   {{ctrl.dato.get('subtotal').value  | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('descuento').value > 0">
                            <span class="panel-icon">
                            <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Descuento:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('descuento').value  | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('iva').value > 0">
                            <span class="panel-icon">
                            <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Iva:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('iva').value  | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block">
                            <span class="panel-icon">
                            <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Total:
                                </div>
                                <div class="column is-6">
                                    {{ctrl.dato.get('total').value  | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('total_recibido').value > 0">
                            <span class="panel-icon">
                            <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%">
                                <div class="column is-6">
                                    Total recibido:
                                </div>
                                <div class="column is-6">
                                   {{ctrl.dato.get('total_recibido').value  | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                </div>
                            </div>
                        </a>
                        <a class="panel-block" *ngIf="ctrl.dato.get('cambio').value > 0">
                            <span class="panel-icon">
                            <i class="fa fa-money"></i>
                            </span>
                            <div class="columns" style="width:100%; color: red">
                                <div class="column is-6">
                                    Devolver:
                                </div>
                                <div class="column is-6">
                                   {{ctrl.dato.get('cambio').value  | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                                </div>
                            </div>
                        </a>
                    </nav>

                </div>
            </div>
        </div>

    </div>
</form>


<!-- ticket -->
<div style="display:none" id="imprimir" >
   <div dir="ltr" *ngIf="reimprimir" style="font-family: sans-serif;font-weight: 900;letter-spacing: .8px;">
      <p align="center" style="margin-bottom:0cm;line-height:100%">
         <br>
      </p>
      <p align="center" style="margin-bottom:0cm;line-height:100%"><br>
      </p>
      <p align="center">
         <font >
         {{ctrl.configuracion.empresa.nombre}}</font>
      </p>
      <p align="center">
         <font >
         {{ctrl.configuracion.empresa.direccion}}
         </font>
      </p>
      <p align="center" style="font-weight:normal"><br>
      </p>
      <hr style="border:2px dashed black;width:100%">
      <p align="center" style="font-style:normal;font-weight:normal">
         <font >{{ctrl.configuracion.sucursal.nombre}}
         </font>
      </p>
      <p align="center" style="font-style:normal;font-weight:normal">
         <font >{{ctrl.configuracion.sucursal.direccion}}</font>
      </p>
      <p align="center" style="font-style:normal;font-weight:normal">
         <font >Tel: {{ctrl.configuracion.sucursal.telefono}} Correo: {{ctrl.configuracion.sucursal.correo}}</font>
      </p>
      <hr style="border:2px dashed black;width:100%">
      <p align="left"> </p>
      <p align="right">
         <font ><span style="font-weight:normal">FOLIO
         : </span><b>{{json.folio}}  </b></font>
      </p>

      <p align="right">
         <font ><span style="font-weight:normal">CODIGO
         : {{json.codigo}}</span><b>  </b></font>
      </p>

      <p align="right" style="font-weight:normal">
            <font ><span style="font-weight:normal">FECHA
         : </span><b>{{json.created_at | formatoFecha}}  </b></font>
       </p>

    <p align="right" style="font-weight:normal" *ngIf="json.personas">
        <font >
            <span style="font-weight:normal">CLIENTE : </span>
            <b>{{json.personas.nombre}} </b>
        </font>
    </p>

      <hr style="border:2px dashed black;width:100%">
      <p align="center" style="margin-bottom:0cm;line-height:100%"><br>
      </p>
      <p align="center" style="margin-bottom:0cm;line-height:100%">
         <font ><b>DEVOLUCIÓN</b></font>
      </p>

      <p align="left"><br>
      </p>
      <table width="100%" cellpadding="4" cellspacing="0" class="table is-striped  is-fullwidth">
         <tr valign="top">
            <td width="15%" style="border:none;padding:0cm">
               <p >
                  <font ><i><b>CANT.</b></i></font>
               </p>
            </td>
            <td width="40%" style="border:none;padding:0cm">
               <p >
                  <font ><i><b>ARTICULO</b></i></font>
               </p>
            </td>
            <td width="20%" style="border:none;padding:0cm">
               <p >
                  <font ><i><b>PRECIO</b></i></font>
               </p>
            </td>
            <td width="25%" style="border:none;padding:0cm">
               <p >
                  <font ><i><b>IMPORTE</b></i></font>
               </p>
            </td>
         </tr>
         <tr *ngFor="let item of json.movimientos_articulos">
            <td>{{item.cantidad}}</td>
            <td>{{item.articulos.nombre}}</td>
            <td>{{item.precio_unitario}}</td>
            <td>{{item.cantidad * item.precio_unitario | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}</td>
         </tr>
      </table>
      <p align="center" style="margin-bottom:0cm;line-height:100%"><br>
      </p>
      <div>
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >TOTAL</font>

                </strong>
                <font >
                    {{json.total | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
        </div>
        <div *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas">
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >{{moneda.nombre}}</font>

                </strong>
                <font >
                    {{(json.total / moneda.tipo_cambio) | currency:moneda.moneda:'symbol'}}
                </font>
            </p>
        </div>
        <div *ngFor="let p of json.pagos">
            <p align="right" style="font-weight:normal">
                <strong>
                    {{p.tipos_formas_pagos.nombre }}
                </strong>
                <font>
                    {{p.importe | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
            <p align="right" style="font-weight:normal">
                <font>
                    {{p.tipos_metodos_pagos.nombre }}
                </font>
            </p>
            <hr style="border:1px dashed black;width:100%">
        </div>
        <div>
            <p align="right" style="font-weight:normal">
                <strong>
                    <font >CAMBIO</font>

                </strong>
                <font >
                    {{json.cambio | currency:ctrl.configuracion.sucursal.moneda:'symbol'}}
                </font>
            </p>
            <div *ngFor="let moneda of ctrl.configuracion.sucursal.conversiones_monedas">
                <p align="right" style="font-weight:normal">
                    <strong>
                        <font >{{moneda.nombre}}</font>

                    </strong>
                    <font >
                        {{(json.cambio / moneda.tipo_cambio) | currency:moneda.moneda:'symbol'}}
                    </font>
                </p>
            </div>
        </div>
      <p align="center" style="margin-bottom:0cm;line-height:100%"><br>
      </p>
      <p align="left">
         <font >
         <span style="font-weight:normal">
         ATENDIÓ :
         </span>
         <span style="font-weight:normal">
         {{json.usuarios ? json.usuarios.nombre : ''}}
         </span>
         </font>
      </p>
      <p align="center" style="font-weight:normal">
         <font >
         Gracias por su compra
         </font>
      </p>
      <p  align="center">
            <img [src]="'data:image/png;base64,' + json.barcode">
       </p>
   </div>
</div>
